<template>

  <div id="login">
    <div style="    position: absolute;width: 10%;z-index: 100000; float:right;margin-left:90%">
      <mt-button icon="more" slot="right" @click="changeLang" style=" background: none;"></mt-button>
    </div>
    <div style="text-align: center">
      <img src="../assets/img/nnn.png" alt style="width:200px;height:200px; padding: 50px;" />
    </div>
    <div id="form-login">
      <mt-field label
                :placeholder="this.$store.getters.WordsConfig.Login.username"
                v-model="form_login.username"></mt-field>
      <mt-field label
                :placeholder="this.$store.getters.WordsConfig.Login.password"
                type="password"
                v-model="form_login.Password"></mt-field>
      <!-- <mt-field label="验证码" v-model="form_login.vertifycode">
      <img src height="45px" width="100px" />
    </mt-field>-->
      <div class="registe">
        <a style="font-size:1.6rem" @click="openPopup">{{this.$store.getters.WordsConfig.Login.no_account}}</a>
      </div>
      <!--<div class="registe">
        <a style="font-size:1.6rem" @click="open2Popup">{{this.$store.getters.WordsConfig.Login.lost_account}}</a>
      </div>-->

      <div style="padding: 0 10px;">
        <mt-button type="primary"
                   size="large"
                   @click="login"
                   class="loginBtn"
                   :disabled="denyClick">{{this.$store.getters.WordsConfig.Login.loginBtn}}</mt-button>
      </div>
    </div>

    <mt-popup v-model="popupVisible"
              position="right"
              :modal="showModal"
              style="width: 100%; height: 100%;">
      <vm-registe @closePopup="closePopup" @loginAfterRegiste="loginAfterRegiste"></vm-registe>
    </mt-popup>

    <!--<mt-popup v-model="popup2Visible"
              position="right"
              :modal="showModal"
              style="width: 100%; height: 100%;">
      <vm-lostaccount @closePopup="close2Popup"></vm-lostaccount>
    </mt-popup>-->



  </div>
</template>

<script>
  import { P_Login, G_UserInfo } from "../api/api.js";
  import Registe from "./Registe.vue";
  export default {
    data() {
      return {
        popupVisible: false,
     
        showModal: false,
        denyClick: false,
        form_login: {
          grant_type: "password",
          username: "",
          Password: ""
        }
      };
    },
    methods: {
      changeLang() {
        this.$store.commit("ChangeLang");
      },
      login() {
        this.denyClick = true;
        //TODO 客户端验证
        if (!this.form_login.username) {
          this.MessageBox({
            title: this.$store.getters.WordsConfig.Login.msgTitle,
            message: this.$store.getters.WordsConfig.Login.msgBox_noName,
            confirmButtonText: this.$store.getters.WordsConfig.MBoxConfirmText
          });
          this.denyClick = false;
          return;
        }
        if (!this.form_login.Password) {
          this.MessageBox({
            title: this.$store.getters.WordsConfig.Login.msgTitle,
            confirmButtonText: this.$store.getters.WordsConfig.MBoxConfirmText,
            message: this.$store.getters.WordsConfig.Login.msgBox_noPsd
          });
          this.denyClick = false;
          return;
        }
        console.log("login");
        //TODO 服务器端验证并获取token
        this.Indicator.open();
        P_Login(this.form_login).then(res => {
          this.denyClick = false;
          this.Indicator.close();
          //登录失败返回信息
          if (res.code != 200) {
            var errormessage = this.$store.getters.WordsConfig.SystemError;
            if (res.code == 40100) {
              errormessage = this.$store.getters.WordsConfig.Login.loginfailed;
            }
            if (res.code == 40106) {
              errormessage = this.$store.getters.WordsConfig.Login.nullity;
            }
            if (res.code == 40107) {
              errormessage = this.$store.getters.WordsConfig.Login.msgBox_waitConfirm;
            }

            this.MessageBox({
              title: this.$store.getters.WordsConfig.Login.msgTitle,
              confirmButtonText: this.$store.getters.WordsConfig.MBoxConfirmText,
              message: errormessage,
              closeOnClickModal: false
            });
            return;
          }


          this.$store.commit("SetToken", res.data);
          this.$router.replace("/");
        
        })
      },
      openPopup() {
        this.popupVisible = true;
      },
     
      closePopup() {
        this.popupVisible = false;
      },
    
      loginAfterRegiste(username, Password) {
        this.form_login.username = username;
        this.form_login.Password = Password;
        this.login();
      }
    },
    components: {
      "vm-registe": Registe
    },
    created() {
      //TODO 读取当前页面文字显示
      if (this.$route.query.status) {
        if (this.$route.query.status === "lose") {
          this.MessageBox({
            title: this.$store.getters.WordsConfig.Login.msgTitle,
            confirmButtonText: this.$store.getters.WordsConfig.MBoxConfirmText,
            message: this.$store.getters.WordsConfig.Login.msgBox_loseToken,
            closeOnClickModal: false
          });
        }
      }
    }
  };
</script>

<style lang="scss">
  #login {
    height: 100%;
    background-color: white;
    background-size: 100% 100%;
    overflow: scroll;
  }

  #form-login {
    width: 100%;
    .registe

  {
    margin-top: 20px;
    text-align: center;
    color: red;
  }

  .loginBtn {
    margin-top: 100px;
  }

  .mint-field {
    margin: 0 15px;
    border-bottom: solid 1px rgba(128, 128, 128, 0.39);
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue